import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MarkdownModule } from 'ngx-markdown';
import { AyudaRoutingModule } from './routing';
import { AyudaComponent } from './ayuda/ayuda.component';

@NgModule({
  declarations: [AyudaComponent],
  imports: [
    CommonModule,
    FormsModule,
    AuxiliaresModule,
    AyudaRoutingModule,
    MarkdownModule.forChild(),
  ],
})
export class AyudaModule {}
